"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TITLE_ALIGN = exports.ICONS = exports.DEVICE_TYPE = exports.COMPONENT_ATTRIBUTES = exports.COLORS = void 0;
var TITLE_ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
exports.TITLE_ALIGN = TITLE_ALIGN;
var DEVICE_TYPE = {
  desktop: 'desktop',
  mobile: 'mobile'
};
exports.DEVICE_TYPE = DEVICE_TYPE;
var COMPONENT_ATTRIBUTES = {
  TEXT_TYPE_DEFAULT: 'default',
  TEXT_TYPE_NORMAL: 'titleNormal',
  ALIGN_CENTER: 'center',
  MARGIN_BOTTOM_SMALL: 'small',
  BUTTONTYPE_BUTTON: 'button',
  BUTTONSIZE_NORMAL: 'normal',
  FONTSIZE_TITLESMALL: 'titleSmall'
};
exports.COMPONENT_ATTRIBUTES = COMPONENT_ATTRIBUTES;
var COLORS = {
  GREY_DARK: 'greyDark',
  NEUTRAL: 'neutral',
  DEFAULT: 'default',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  PRIMARY_DARK: 'primaryDark',
  NONE: 'none'
};
exports.COLORS = COLORS;
var ICONS = {
  FLIGHT_ICON: 'FlightIcon'
};
exports.ICONS = ICONS;